import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import Img01 from "../../images/services/et/Artificial_Intelligence.webp";
import Img02 from "../../images/services/et/Blockchain-technology.webp";
import Img03 from "../../images/services/et/Internet-Things.webp";
import Img04 from "../../images/services/et/Virtual-Reality.webp";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Servicespartner(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Solutions">
                            <h2>Embracing The Change With Emerging Technologies For A Better Tomorrow</h2>
                        </div>
                        <h5 className="strong">Why partner with TekRevol to leverage emerging technologies for your
                            business?</h5>
                        <p>TekRevol is an experienced team of skilled individuals building state-of-the-art solutions
                            and incredible systems to help businesses worldwide. Our work with Fortune 500 companies and
                            more than 500+ small, medium and enterprise-scale organizations has enabled us to understand
                            the changing requirements of the modern world and keep up with the demands.</p>
                        <p> TekRevol knows your business needs and how you can strategically devise your policies and
                            work accordingly. We are customer-focused and are ready to go to the lengths to use emerging
                            technologies for better outcomes.</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-5 offset-lg-1">
                        <Row>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img01}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Artificial Intelligence</p>
                                </div>
                                <div className="set_of_images hover01 mt-4">
                                    <LazyLoadImage
                                        src={Img03}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Internet Things</p>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-lg-4 mt-md-0">
                                <div className="set_of_images hover01">
                                    <LazyLoadImage
                                        src={Img02}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Blockchain Technology</p>
                                </div>
                                <div className="set_of_images hover01  mt-4">
                                    <LazyLoadImage
                                        src={Img04}
                                        effect="blur" alt="Image" className="img-fluid"
                                    />
                                    <p className="img_title">Virtual Reality</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Servicespartner;